import { ChangeDetectionStrategy, Component, Input, output, input } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';

import { ButtonComponent } from '../../common/button/components/button/button.component';
import { MessageComponent } from '../../common/message/message.component';

@Component({
  selector: 'rt-bulk-selection-messages',
  templateUrl: './bulk-selection-messages.component.html',
  styleUrls: ['./bulk-selection-messages.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MessageComponent, ButtonComponent, TranslatePipe],
})
export class BulkSelectionMessagesComponent {
  public readonly hasBottomMargin = input<boolean>(true);
  public readonly hasTopMarginMedium = input<boolean>(true);
  @Input() public currentViewSelectedCount: number;
  @Input() public selectedCount: number;

  public clearSelection = output<void>();
}
